// extracted by mini-css-extract-plugin
export default {"optionsMain":"Options_optionsMain__gxbHd","alternativeOptions":"Options_alternativeOptions__lcszC","textOptions":"Options_textOptions__gEY2b"};